<template>
    <Menu :spaced="spaced">
        <MenuLink
            v-if="user.status !== 'active'"
            :disabled="submitting"
            :icon="faEnvelope"
            label="Resend invite"
            @click="resendInvite"
        />
        <MenuLink
            :disabled="submitting"
            :icon="faPenToSquare"
            label="Edit"
            @click="editUser"
        />
        <MenuLink
            :disabled="submitting"
            :icon="faTrash"
            label="Delete"
            @click="deleteUser"
        />
    </Menu>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from '@evidentid/vue-property-decorator';

    import { faEnvelope, faTrash } from '@fortawesome/free-solid-svg-icons';
    import { faPenToSquare } from '@fortawesome/pro-light-svg-icons';

    import { Menu, MenuLink } from '@evidentid/dashboard-commons/components/Menu';
    import type { User } from '@evidentid/user-management-api-client/types';

    @Component({
        emits: [ 'delete', 'edit', 'resendInvite' ],
        components: {
            MenuLink,
            Menu,
        },
    })
    export default class UserActionsMenu extends Vue {
        private faEnvelope = faEnvelope;
        private faPenToSquare = faPenToSquare;
        private faTrash = faTrash;

        @Prop({ type: Object })
        private user!: User;

        @Prop({ type: Boolean, default: false })
        private submitting!: boolean;

        @Prop({ type: Boolean, default: false })
        private spaced!: boolean;

        @Prop({ type: Boolean, default: false })
        private preventEvents!: boolean;

        private processEvent(event: Event | null | undefined): void {
            if (event && this.preventEvents) {
                event.preventDefault();
                event.stopPropagation();
            }
        }

        private resendInvite(event: Event): void {
            this.processEvent(event);
            if (!this.submitting) {
                this.$emit('resendInvite');
            }
        }

        private editUser(event: Event): void {
            this.processEvent(event);
            if (!this.submitting) {
                this.$emit('edit');
            }
        }

        private deleteUser(event: Event): void {
            this.processEvent(event);
            if (!this.submitting) {
                this.$emit('delete');
            }
        }
    }
</script>
